// Navigation
export const NAV_LINKS = [
  { name: 'Forside', path: '/' },
  { name: 'Blog', path: '/blog' },
  { name: 'Konsultation', path: '/consultation' },
  { name: 'Quiz', path: '/quizzes' },
  { name: 'Om os', path: '/about' },
];

// Blog categories
export const BLOG_CATEGORIES = [
  'Ernæring',
  'Sundhed',
  'Træning',
  'Adfærd',
  'Pleje',
  'Opskrifter',
  'Generelt',
];

// Quiz difficulties
export const QUIZ_DIFFICULTIES = [
  'Let',
  'Mellem',
  'Svær',
];

// Social media links
export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/snudefryd',
  facebook: 'https://www.facebook.com/snudefryd',
  twitter: 'https://www.twitter.com/snudefryd',
};

// Contact information
export const CONTACT_INFO = {
  email: 'erica@snudefryd.dk',
  phone: '+45 51971642',
  address: 'Hundevej 42, 2100 København Ø',
};

// Dog sizes
export const DOG_SIZES = [
  'Meget lille (under 5 kg)',
  'Lille (5-10 kg)',
  'Mellem (10-25 kg)',
  'Stor (25-45 kg)',
  'Meget stor (over 45 kg)',
];

// Dog ages
export const DOG_AGES = [
  'Hvalp (0-1 år)',
  'Ung (1-3 år)',
  'Voksen (3-7 år)',
  'Senior (7+ år)',
];

// Form validation messages
export const VALIDATION_MESSAGES = {
  required: 'Dette felt er påkrævet',
  email: 'Indtast en gyldig e-mailadresse',
  phone: 'Indtast et gyldigt telefonnummer (8 cifre)',
  postalCode: 'Indtast et gyldigt postnummer (4 cifre)',
  minLength: (length: number) => `Skal være mindst ${length} tegn`,
  maxLength: (length: number) => `Må højst være ${length} tegn`,
}; 
